import { TFunction } from "i18next";
import { FeatureOption } from "../types/feature.definition";

const FEATURE_CODE_PATTERN = /^[A-Z0-9]+(?:_[A-Z0-9]+)*$/;

/** "SMS_EMAIL_REMINDERS" → "Sms email reminders". */
export const humaniseFeatureCode = (code: string): string => {
  const words = code.toLowerCase().split("_").join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** "SMS_EMAIL_REMINDERS" → "smsEmailReminders" (the licenses.features key). */
const toFeatureKey = (code: string): string =>
  code.toLowerCase().replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());

/**
 * A plan stores feature codes. Show the feature's label in the UI language
 * when the API has one, else this app's own translation for the code, else
 * the code made readable — never the raw code. A free-text entry (not a code)
 * is shown as typed.
 */
export const getFeatureLabel = (
  code: string,
  availableFeatures: FeatureOption[],
  t: TFunction
): string => {
  const apiLabel = availableFeatures.find(f => f.code === code)?.label;
  if (apiLabel && apiLabel !== code) return apiLabel;
  if (!FEATURE_CODE_PATTERN.test(code)) return code;
  return t(`licenses.features.${toFeatureKey(code)}`, {
    defaultValue: humaniseFeatureCode(code),
  });
};
